export const aboutInformationArray = [
  {
    type: "image",
    source: "/projects/about/stephanie.jpg",
  },
  {
    type: "description",
    text: "I'm Stephanie Hays, a designer, developer and art director.",
    texttwo:
      "I'm currently a Senior Designer at The Washington Post, where I work on wide-ranging projects across the newsroom, from a historical series about Thomas Jefferson, to the branding of total solar eclipse coverage, to a redesign of our quiz template. Previously, I was a designer at The Seattle Times and the lead designer at the Sacramento Business Journal. Outside of work, you can find me rock climbing or taking photos.",
  },
  {
    type: "Selected awards",
    awards: [
      {
        title: "Pulitzer Prize, National Reporting (staff)",
        organization: "Pulitzer Prizes",
        year: 2024,
      },
      {
        title: "Best in Show",
        organization: "Society for News Design",
        year: 2024,
      },
      {
        title: "Gold Medal for International Staff Portfolio",
        organization: "Society for News Design",
        year: 2026,
      },
      {
        title: "Silver Medal for Individual Portfolio",
        organization: "Society for News Design",
        year: 2024,
      },
      {
        title: "Silver Medal for Inside Pages (News)",
        organization: "Society for News Design",
        year: 2024,
      },
      {
        title: "Silver Medal for Single Section",
        organization: "Society for News Design",
        year: 2024,
      },
      {
        title: "Bronze Medal for National Illustrations",
        organization: "Society for News Design",
        year: 2026,
      },
      {
        title: "Bronze Medal for National Line of Coverage",
        organization: "Society for News Design",
        year: 2026,
      },
      {
        title: "Awards of Excellence for Print and Combination Portfolios",
        organization: "Society for News Design",
        year: 2026,
      },
      {
        title:
          "Awards of Excellence for Digital, Print and Combination Portfolios",
        organization: "Society for News Design",
        year: 2025,
      },
      {
        title: "International Finalist",
        organization: "Gerald Loeb Awards",
        year: 2025,
      },
      {
        title: "University of Florida Award for Investigative Data Journalism",
        organization: "Online News Association",
        year: 2024,
      },
    ],
  },
  {
    type: "Programs",
    programs: [
      {
        title: "Executive Leadership Program",
        organization: "Asian American Journalists Association",
        year: 2021,
      },
    ],
  },
  {
    type: "Speaking",
    programs: [
      {
        title: "Featured speaker",
        organization: "JEA/NSPA National High School Journalism Convention",
        year: 2021,
        presentation: "Creating compelling visuals for complex stories",
      },
    ],
  },
];
